// extracted by mini-css-extract-plugin
export default {"spinner_container":"styles_spinner_container__0-O-0","custom_spinner":"styles_custom_spinner__ODbDj"};